import styled from 'styled-components'

import { mq, sizes } from '../../../theme'
import _TagAge from '../TagAge'

export const Container = styled.div<{ $backgroundColor?: string }>`
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: left;
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  padding: 1.6rem;
  border-radius: 2rem;

  @media ${mq(sizes.desktop)} {
    min-width: 100%;
  }
`

export const TagAge = styled(_TagAge)`
  margin-bottom: 0.8rem;
`

export const Text = styled.span`
  ${({ theme }) => theme.textStyles.text_16}
  color: ${({ theme }) => theme.colors.pureBlack};
  word-break: break-word;
`
